import { requestApi } from "./api";

export interface Notice {
  id: string;
  code: string;
  title: string;
  content: string;
  publishMethod: "IMMEDIATE" | "SCHEDULED";
  startDate: string;
  endDate: string;
  active: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface Inquiry {
  id: string;
  code: string;
  memberId: string;
  memberCode: string;
  memberLoginId: string;
  memberName: string;
  phone: string;
  email: string;
  memberCreatedAt: string | null;
  category: string;
  title: string;
  content: string;
  status: "PENDING" | "ANSWERED";
  answer: string;
  answeredBy: string;
  answeredAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface NoticeInput {
  title: string;
  content: string;
  publishMethod: Notice["publishMethod"];
  startDate: string;
  endDate: string;
  active: boolean;
}

export interface InquiryInput { category: string; title: string; content: string; }
export interface PageResult<T> { items: T[]; totalElements: number; page: number; size: number; }

export const getPublicNotices = () => requestApi<Notice[]>("/notices");
export const getPublicNotice = (code: string) => requestApi<Notice>(`/notices/${encodeURIComponent(code)}`);
export const getMemberInquiries = () => requestApi<Inquiry[]>("/inquiries");
export const getMemberInquiry = (code: string) => requestApi<Inquiry>(`/inquiries/${encodeURIComponent(code)}`);
export const createInquiry = (input: InquiryInput) => requestApi<Inquiry>("/inquiries", { method: "POST", body: JSON.stringify(input) });

export const getAdminNotices = () => requestApi<Notice[]>("/admin/notices");
export const getAdminNoticesPage = (input: Record<string, string | number | boolean | undefined>) => { const query = new URLSearchParams(); Object.entries(input).forEach(([key, value]) => { if (value !== undefined && value !== "") query.set(key, String(value)); }); return requestApi<PageResult<Notice>>(`/admin/notices/search?${query.toString()}`); };
export const saveAdminNotice = (input: NoticeInput, code?: string) => requestApi<Notice>(code ? `/admin/notices/${encodeURIComponent(code)}` : "/admin/notices", { method: code ? "PUT" : "POST", body: JSON.stringify(input) });
export const deleteAdminNotices = (codes: string[]) => requestApi<{ deleted: number }>("/admin/notices", { method: "DELETE", body: JSON.stringify({ codes }) });
export const getAdminInquiries = () => requestApi<Inquiry[]>("/admin/inquiries");
export const getAdminInquiriesPage = (input: Record<string, string | number | undefined>) => { const query = new URLSearchParams(); Object.entries(input).forEach(([key, value]) => { if (value !== undefined && value !== "") query.set(key, String(value)); }); return requestApi<PageResult<Inquiry>>(`/admin/inquiries/search?${query.toString()}`); };
export const answerAdminInquiry = (code: string, answer: string) => requestApi<Inquiry>(`/admin/inquiries/${encodeURIComponent(code)}/answer`, { method: "PUT", body: JSON.stringify({ answer }) });
